import { Grid } from "@mui/material";
import MDBox from "components/MDBox";

import { FormTitle, Text, SelectField } from "ui-components/Form";

function CountryInfo({ formRender, control, errors, mode = "ADD" }) {
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Country Information" : "Country Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { editable, ...data } = property;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(mode === "EDIT" && editable === false && { disabled: true }),
              };
              let renderField;
              switch (data.type) {
                case "text":
                  renderField = <Text field={fieldProps} />;
                  break;
              }
              return (
                <Grid item xs={12} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default CountryInfo;
